<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => setProtect(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    declare var eLock: any;
    @Component({
        components: {
            MenuList,
        },
    })
    export default class LockExpand extends Vue {
        get menuList() {
            return {
                // list: [
                //     { key: 0, label: this.$t("width"), checked: this.lockStatus['Width']},
                //     { key: 1, label: this.$t("height"), checked: this.lockStatus['Height']},
                //     { key: 2, label: this.$t("ratio"), checked: this.lockStatus['WHCalc']},
                //     { key: 3, label: this.$t("horizontal"), checked: this.lockStatus['X']},
                //     { key: 4, label: this.$t("vertical"), checked: this.lockStatus['Y']},
                //     { key: 5, label: this.$t("rotate"), checked: this.lockStatus['Rotate']},
                //     { key: 6, label: this.$t("begin"), checked: this.lockStatus['Begin']},
                //     { key: 7, label: this.$t("end"), checked: this.lockStatus['End']},
                //     { key: 8, label: this.$t("group"), checked: this.lockStatus['Group']},
                //     { key: 9, label: this.$t("text"), checked: this.lockStatus['TextEdit']},
                //     { key: 10, label: this.$t("select"), checked: this.lockStatus['Select']},
                //     { key: 11, label: this.$t("delete"), checked: this.lockStatus['Delete']},
                //     { key: 12, label: this.$t("link"), checked: this.lockStatus['Connector']},
                //     // 列表中的其他项 key 为数字时，divide 项也要设置 key 值以防与后一项重复
                //     { key: "divide", divide: true },
                //     { key: 13, label: this.$t("format"), checked: this.lockStatus['Format']},
                //     { key: 14, label: this.$t("groupFormat"), checked: this.lockStatus['GrpFmt_Format']},
                //     { key: 15, label: this.$t("groupFill"), checked: this.lockStatus['GrpFmt_Fill']},
                //     { key: 16, label: this.$t("theme"), checked: this.lockStatus['From_Theme']},
                //     { key: 17, label: this.$t("snapOutline"), checked: this.lockStatus['SnapOutline']},
                // ]
                list: [
                    { key: 0, label: this.$t("width"), checked: this.lockStatus["Width"] },
                    { key: 1, label: this.$t("height"), checked: this.lockStatus["Height"] },
                    { key: 2, label: this.$t("ratio"), checked: this.lockStatus["WHCalc"] },
                    { key: "divide1", divide: true },
                    { key: 3, label: this.$t("horizontal"), checked: this.lockStatus["X"] },
                    { key: 4, label: this.$t("vertical"), checked: this.lockStatus["Y"] },
                    { key: "divide2", divide: true },
                    { key: 5, label: this.$t("rotate"), checked: this.lockStatus["Rotate"] },
                    { key: "divide3", divide: true },
                    { key: 6, label: this.$t("begin"), checked: this.lockStatus["Begin"] },
                    { key: 7, label: this.$t("end"), checked: this.lockStatus["End"] },
                    { key: "divide4", divide: true },
                    { key: 9, label: this.$t("text"), checked: this.lockStatus["TextEdit"] },
                    { key: 13, label: this.$t("format"), checked: this.lockStatus["Format"] },
                    { key: "divide5", divide: true },
                    // { key: 10, label: this.$t("select"), checked: this.lockStatus["Select"] },
                    { key: 11, label: this.$t("delete"), checked: this.lockStatus["Delete"] },
                    { key: 12, label: this.$t("link"), checked: this.lockStatus["Connector"] },
                    { key: "divide6", divide: true },
                    { key: 8, label: this.$t("group"), checked: this.lockStatus["Group"] },
                    { key: 14, label: this.$t("groupFormat"), checked: this.lockStatus["GrpFmt_Format"] },
                    { key: 16, label: this.$t("theme"), checked: this.lockStatus["From_Theme"] },
                ],
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        setProtect(index) {
            let strArr = [
                "width",
                "height",
                "ratio",
                "horizontal",
                "vertical",
                "rotate",
                "begin",
                "end",
                "group",
                "text",
                "select",
                "delete",
                "link",
                "format",
                "groupFormat",
                "groupFill",
                "theme",
                "snapOutline",
            ];
            this.$track("menu", "layout", "lock" + strArr[index]);
            window["_view"].protectChanged(index);
            this.closeDrop();
        }
        get lockStatus() {
            return this.$store.state.ui.lockStatus;
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "width": "宽度",
    "height": "高度",
    "ratio": "横纵比",
    "horizontal": "X轴位置",
    "vertical": "Y轴位置",
    "rotate": "旋转",
    "begin": "起点",
    "end": "终点",
    "group": "阻止取消组合",
    "text": "文本",
    "select": "阻止选择",
    "delete": "阻止删除",
    "link": "阻止连接",
    "format": "样式",
    "groupFormat": "阻止应用组合样式",
    "groupFill": "组合填充",
    "theme": "阻止应用主题",
    "snapOutline": "连接轮廓"
  },
  "en": {
    "width": "Width",
    "height": "Height",
    "ratio": "Aspect Ratio",
    "horizontal": "X Position",
    "vertical": "Y Position",
    "rotate": "Rotation",
    "begin": "Begin Point",
    "end": "End Point",
    "group": "Ungroup",
    "text": "Edit Text",
    "select": "From Selection",
    "delete": "From Deletion",
    "link": "From Connector",
    "format": "Format",
    "groupFormat": "From Group Formatting",
    "groupFill": "From Group Fill",
    "theme": "From Theme",
    "snapOutline": "From Snapping to Outline"
  },
  "fr": {
    "width": "Largeur",
    "height": "Hauteur",
    "ratio": "Ratio d'aspect",
    "horizontal": "Position X",
    "vertical": "Position Y",
    "rotate": "Rotation",
    "begin": "Point de Départ",
    "end": "Point Final",
    "group": "Dissocier",
    "text": "Éditer le Texte",
    "select": "De la Sélection",
    "delete": "De la Suppression",
    "link": "Protéger du Connecteur",
    "format": "Format",
    "groupFormat": "From Group Formatting",
    "groupFill": "Du Remplissage de Groupe",
    "theme": "Du Thème",
    "snapOutline": "Contour de Connexion"
  },
  "de": {
    "width": "Breite",
    "height": "Höhe",
    "ratio": "Seitenverhältnis",
    "horizontal": "X Position",
    "vertical": "Y Position",
    "rotate": "Drehung",
    "begin": "Startpunkt",
    "end": "Endpunkt",
    "group": "Gruppierung auflösen",
    "text": "Text bearbeiten",
    "select": "Aus Auswahl",
    "delete": "Aus Löschen",
    "link": "Aus Verbinder",
    "format": "Format",
    "groupFormat": "Aus Gruppenformatierung",
    "groupFill": "Aus Gruppenfüllung",
    "theme": "Aus Thema",
    "snapOutline": "Vom Einrasten zur Gliederung"
  },
  "jp": {
    "width": "幅",
    "height": "高さ",
    "ratio": "縦横比",
    "horizontal": "水平位置",
    "vertical": "垂直位置",
    "rotate": "回転",
    "begin": "始点",
    "end": "終点",
    "group": "グループ化解除",
    "text": "テキストを編集",
    "select": "選択したもの",
    "delete": "削除しないまま",
    "link": "接続しないまま",
    "format": "書式",
    "groupFormat": "グループの書式",
    "groupFill": "グループの塗りつぶし",
    "theme": "テーマ",
    "snapOutline": "アウトラインにスナップ"
  },
  "es": {
    "width": "Ancho",
    "height": "Altura",
    "ratio": "Relación de aspecto",
    "horizontal": "Posición X",
    "vertical": "Posición Y",
    "rotate": "Rotación",
    "begin": "Punto de partida",
    "end": "Punto final",
    "group": "Desagruparse",
    "text": "Editar texto",
    "select": "De la selección",
    "delete": "De la eliminación",
    "link": "De Conector",
    "format": "Formato",
    "groupFormat": "Del formato de grupo",
    "groupFill": "Del Grupo Fill",
    "theme": "Del tema",
    "snapOutline": "Del chasquido al contorno"
  },
  "pt": {
    "width": "Largura",
    "height": "Altura",
    "ratio": "Razão de Aspecto",
    "horizontal": "Posição X",
    "vertical": "Posição Y",
    "rotate": "Rotação",
    "begin": "Ponto Inicial",
    "end": "Ponto Final",
    "group": "Desagrupar",
    "text": "Editar Texto",
    "select": "De Seleção",
    "delete": "De Eliminação",
    "link": "De Conector",
    "format": "Formato",
    "groupFormat": "De Grupo de Formatação",
    "groupFill": "De Grupo de Preenchimento",
    "theme": "De Tema",
    "snapOutline": "De Encaixe para Contorno"
  },
  "it": {
    "width": "Larghezza",
    "height": "Altezza",
    "ratio": "Rapporto di Aspetto",
    "horizontal": "Posizione X",
    "vertical": "Posizione Y",
    "rotate": "Rotazione",
    "begin": "Punto di Inizio",
    "end": "Punto di Fine",
    "group": "Separa",
    "text": "Modifica Testo",
    "select": "Da Selezione",
    "delete": "Da Eliminazione",
    "link": "Da Connettore",
    "format": "Formato",
    "groupFormat": "Da Formattazione Gruppo",
    "groupFill": "Da Riempimento Gruppo",
    "theme": "Da Tema",
    "snapOutline": "Da Aggancio al Contorno"
  },
  "tw": {
    "width": "寬度",
    "height": "高度",
    "ratio": "橫縱比",
    "horizontal": "水平位置",
    "vertical": "垂直位置",
    "rotate": "旋轉",
    "begin": "起點",
    "end": "終點",
    "group": "取消組合",
    "text": "編輯文本",
    "select": "選中",
    "delete": "刪除",
    "link": "連接",
    "format": "格式",
    "groupFormat": "組合格式",
    "groupFill": "組合填充",
    "theme": "主題",
    "snapOutline": "連接輪廓"
  }
}
</i18n>
